<template>
  <div>
    <el-table ref="multipleTable" :data="localTableData" style="width: 100%;color: black;" class="--modal-table"
      @selection-change="handleSelectionChange">
      <el-table-column label="Media" width="100">
        <template slot-scope="scope">
          <img style="width: 50px; height: 50px;" :src="scope.row.media" :alt="scope.row.name" />
        </template>
      </el-table-column>
      <el-table-column property="name" label="Name" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="Destination URL" width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="d-flex align-items-center" style="gap: 8px; cursor: pointer;" @click.stop="openEdit(scope.row)">
            <span>{{ scope.row.destination ? scope.row.destination : '-' }}</span>
            <i class="fa-solid fa-pen-to-square"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="date" label="Uploaded on" show-overflow-tooltip>
      </el-table-column>
      <el-table-column property="size" label="Size" show-overflow-tooltip :formatter="formatSize"></el-table-column>
      <el-table-column property="dimensions" label="Dimensions" show-overflow-tooltip></el-table-column>
      <el-table-column label="Action" align="right">
        <template slot-scope="scope">
          <i class="fa-solid fa-trash" style="cursor: pointer;" @click.stop="removeMedia(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <modal centered :show.sync="modals.destination" id="updateDestination" type="mini"
      bodyClasses="create-campaign-modal-body" footerClasses="border-top p-2" :appendToBody="false"
      modalClasses="medium-modal">
      <div slot="header" class="border-bottom pb-3 w-100">
        <h3 class="title title-up">Edit Destination URL</h3>
      </div>
      <div class="d-flex align-items-center">
        <base-input label="Destination URL" type="text" placeholder="e.g., https://www.example.com/"
          v-model="activeEditRow.destination" class="mb-0 pb-0 w-100">
        </base-input>
      </div>
      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
          <base-button class="d-none" @click="updateDestination" style="height:40px">

          </base-button>
          <base-button @click="updateDestination" size="sm" style="height:40px">
            Update
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button
} from "element-ui";
import { Modal } from "src/components";

export default {
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
  },
  props: {
    masterDestinationURL: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    selectedMediaIds: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'add',
      validator: (value) => ['add', 'edit'].includes(value),
    },
    campaignId: {
      type: [String, Number],
      default: null,
    }
  },
  data() {
    return {
      modals: {
        destination: false,
      },
      // tableData: [
      //   {
      //     id: "1",
      //     date: "2016-05-03",
      //     name: "Tom",
      //     size: "150KB",
      //     dimensions: "120 X 120 PX",
      //     destination: "",
      //     media:
      //       "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
      //   },
      //   {
      //     id: "2",
      //     date: "2016-05-03",
      //     name: "Tom",
      //     size: "150KB",
      //     dimensions: "120 X 120 PX",
      //     destination: "",
      //     media:
      //       "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
      //   },
      //   {
      //     id: "3",
      //     date: "2016-05-03",
      //     name: "Tom",
      //     size: "150KB",
      //     dimensions: "120 X 120 PX",
      //     destination: "",
      //     media:
      //       "https://emmbetaspaces.nyc3.cdn.digitaloceanspaces.com/users/profile/_profilephoto_143_0ba5e36a5d23ece40104b38af3298524.png"
      //   }
      // ],
      multipleSelection: [],
      activeEditRow: {},
      localTableData: [],
      originalTableData: [],
      lastSnapshotCampaignId: null,
    };
  },

  methods: {
    formatSize(row, column, value) {
      if (!value) return "-";
      const kb = parseFloat(value);
      const mb = kb / 1024;
      return `${mb.toFixed(2)} MB`;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("media-selection-changed", val);
    },
    openEdit(row) {
      this.activeEditRow = row
      this.modals.destination = !this.modals.destination
    },
    async updateDestination() {
      const row = this.localTableData.find(item => item.id === this.activeEditRow.id);
      if (row) {
        let payload = {
          media_id : row.id,
          param : {
            target_url : this.activeEditRow.destination,
            organization_id : row.leadspeek_organizationid,
            leadspeek_api_id : row.leadspeek_api_id,
            simplifi_media_id : row.simplifi_id
          }
        }        
        if (row.simplifi_id) {
          await this.$store.dispatch('UpdateMedia',{
            data: payload
          }).then(response => {
              this.$notify({
                type: 'success',
                message: 'Media Destination updated Successfully',
                icon: 'far fa-save',
              })
              row.destination = response.media.target_url || row.destination;
              this.modals.destination = false
          }).catch(error => {                
              if (error && error.status === 422 && error.errors) {
                  Object.entries(error.errors).forEach(([field, messages]) => {
                      messages.forEach(message => {
                          this.$notify({
                              type: 'danger',
                              message: message || "Something's wrong, please try again later.",
                              icon: 'fas fa-bug',
                          });
                      });
                  });
              } else {
                  this.$notify({
                      type: 'danger',
                      message: (error.response.data.message) 
                                || error.message 
                                || "Something's wrong, please try again later.",
                      icon: 'fas fa-bug',
                  });
              }
          })
        }
        row.destination = this.activeEditRow.destination;
        this.modals.destination = false
      } else {
        console.warn('No matching row found.');
      }
      this.$emit('update-media-data', JSON.parse(JSON.stringify(this.localTableData)));
    },
    removeMedia(row) {
      this.localTableData = this.localTableData.filter(item => item.id !== row.id);
      this.$emit('remove-media', row.id);
    },
    setSelection(selectedIds) {      
      if (!this.$refs.multipleTable) return;
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
        this.localTableData.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
        this.$emit("media-selection-changed", this.localTableData);
      });
    },
  },
  watch: {
masterDestinationURL(newVal) {
      if (!this.localTableData.length) return;
      let changed = false;

      if (this.mode === 'edit') {
        this.localTableData.forEach((media, index) => {
          const originalMedia = this.originalTableData.find(item => item.id === media.id);
          
          if (!originalMedia || (originalMedia && !originalMedia.destination)) {
            if (media.destination !== newVal) {
              media.destination = newVal;
              changed = true;
            }
          }
        });

      } else { // mode 'add'
        this.localTableData.forEach(media => {
          if (media.destination !== newVal) {
            media.destination = newVal;
            changed = true;
          }
        });
      }

      if (changed) {
        this.$emit('update-media-data', JSON.parse(JSON.stringify(this.localTableData)));
      }
    },
    tableData: {
      immediate: true,
      deep: true,
      handler(newData) {
        const newDataString = JSON.stringify(newData);
        this.localTableData = JSON.parse(newDataString);
        
        if (this.mode === 'edit') {
          if (this.lastSnapshotCampaignId === null || this.lastSnapshotCampaignId !== this.campaignId) {
            this.originalTableData = JSON.parse(newDataString);
            this.lastSnapshotCampaignId = this.campaignId;
          }
        }
        
        this.$emit("media-selection-changed", this.localTableData);
      }
    }
  }
};
</script>
<style>
.--modal-table.el-table table {
  color: unset !important;
}

.medium-modal {
  max-width: 550px !important;
}
</style>
